export const Add_SPECIAL_DEALS_REQUEST = 'Add_SPECIAL_DEALS_REQUEST'
export const Add_SPECIAL_DEALS_SUCCESS = 'Add_SPECIAL_DEALS_SUCCESS'
export const Add_SPECIAL_DEALS_FALIURE = 'Add_SPECIAL_DEALS_FALIURE'